import Slider, * as QuizzSlider from "./game-quizz-slider"
// import Panzoom, * as GamePanzoom from "./game-panzoom"
import Modal from "./modal"
import Game from "./game"

const isGameQuizz = document.querySelector("#game-quizz")
const panzoomContainer = document.querySelector("#js-panzoom-quizz")
const fraction = document.querySelector("#swiper-fraction")
const pagination = document.querySelector("#swiper-pagination")
const buttonNext = document.querySelector("#swiper-next")

var panzoom2 = "";
var scores = {}

var score = 0;
var panzoom2;

var breakpoint_mobile_carte = 1000;
var largeur_ecran = window.outerWidth;

var scale_desktop = 0.8;
// var scale_desktop = 1;


const Quizz = {
	init: () => {
		if (!isGameQuizz) return
		// let panzoomShow = Panzoom.initQuizzPanzoom(panzoomContainer)
		let panzoomShow = ""
		let swiper = Slider.initSwiper()

		let targetPos = Quizz.getCurrentSceneAttr(swiper)

		var img = new Image();
		var img_map = document.querySelector("#js-panzoom-canvas").src;

		// Session storage
		if(sessionStorage.getItem("scores") === null){
			sessionStorage.setItem("scores", JSON.stringify({}));
		}

		// Positions
		var positions = Quizz.calcul_positions(targetPos)
		
		img.onload = function() {
		
			document.querySelector("#js-panzoom-canvas").src = img_map;
			
			const elem = document.getElementById('js-panzoom-main-menu')
			
			panzoom2 =  Panzoom(document.getElementById('js-panzoom-canvas'), { 
				// contain: 'outside', 
				animate: true,
				duration: 800,
				startScale: largeur_ecran < breakpoint_mobile_carte ? 0.4 : scale_desktop,
				canvas: false,
				startX: positions.x,
				startY: positions.y	
			})

			document.querySelector("#js-panzoom-canvas").classList.remove("hidden")
			document.querySelector("#loader").classList.add("hidden")
		
			if(swiper.realIndex > 0)
				Quizz.updateScene(panzoomShow, swiper)
		};
		
		Quizz.bindEvents(swiper, panzoomShow)
		
		img.src = img_map;


	},

	clamp : function(value, min, max) {
		return Math.min(Math.max(value, min), max);
	},

	calcul_positions: function(targetPos){
		var pos_x_desktop = Math.abs(parseInt(targetPos.x)) < 50 ? parseInt(targetPos.x) : parseInt(targetPos.x) - ((1911 - window.outerWidth) / 2);
		var pos_y_desktop = parseInt(targetPos.y) - (400 - document.querySelector(".game-quizz__image").offsetHeight)
		
		// var pos_x_mobile = (parseInt(targetPos.x) - ((1911 - 250) / 2)) * 2;
		var pos_x_mobile = (parseInt(targetPos.x) - ((1911 - document.querySelector(".game-quizz__image").offsetWidth) / 2) * 2) - (1920 / 2) - targetPos.deltaXMobile;
		var max_y = (((1080 - document.querySelector(".game-quizz__image").offsetHeight) * 2.5) + 1080) *-1

		var decalage_overflow = ((window.innerHeight - document.querySelector(".site-header").offsetHeight) / 2) - (400 - window.innerHeight);
		var pos_y_mobile = (parseInt(targetPos.y) - ((400 - document.querySelector(".game-quizz__image").offsetHeight) / 2) * -2) - (1080) - targetPos.deltaYMobile
		var pos_y_mobile = (parseInt(targetPos.y) - ((400 - document.querySelector(".game-quizz__image").offsetHeight) / 2) * -2) - (1080) - targetPos.deltaYMobile - decalage_overflow;


		var max_x_desktop = (((1911 - window.outerWidth) * (1 / scale_desktop)) + 1911) *-1;


		if(scale_desktop == 0.8){

			pos_x_desktop-=310;
			pos_y_desktop-=170;

			pos_x_desktop = Quizz.clamp(pos_x_desktop,max_x_desktop,-480)
		}

		// Scale 0.4
		pos_x_mobile-=900
		pos_y_mobile-=290	

		pos_y_mobile = Quizz.clamp(pos_y_mobile,max_y,0)

		var pos = {
			x : 0,
			y : 0
		}

		if(window.outerWidth < breakpoint_mobile_carte){
			pos.x = pos_x_mobile
			pos.y = pos_y_mobile
		}else{
			pos.x = pos_x_desktop
			pos.y = pos_y_desktop
		}

		return pos

	},

	bindEvents: (swiper, panzoom) => {
		// events clicks
		document.addEventListener("click", function (e) {
			// boutons réponses
			if (e.target.dataset.answer) {
				Quizz.handleAnswer(e.target, swiper)
			}
			// bouton next
			if (buttonNext.contains(e.target)) {
				// button next is altered
				if (buttonNext.dataset.openModal) {
					let modal = document.querySelector(buttonNext.dataset.openModal)
					Modal.open(modal)


					if(score < 4){
						modal.classList.add("c")
					}

					if(score >= 4 && score < 7){
						modal.classList.add("b")
					}

					if(score >= 7){
						modal.classList.add("a")
					}

					// Session stage
					var score_session = JSON.parse(sessionStorage.getItem("scores"));
					score_session[swiper.wrapperEl.id] = score;
					sessionStorage.setItem("scores", JSON.stringify(score_session));
					
					// !! END GAME -- TEMPORAIRE -- A DEPLACER !!
					Game.end()
				}
				// last slide
				if (swiper.isEnd) {
					Quizz.alterButtonNext("Voir mes résultats", "#js-modal-end-quizz")
				}
				Quizz.hideButtonNext()
			}
		})
		// set pagination modules on load
		Slider.setPaginationStyle(pagination, swiper)
		Slider.setPaginationFraction(fraction, swiper)
		// events onSlideChange (e === swiperObject)
		swiper.on("slideChange", function (e) {
			Slider.updatePaginationProgress(pagination, e)
			Slider.setPaginationFraction(fraction, e)
			Quizz.updateScene(panzoom, e)
		})
	},

	/**
	 * Récupère les attributs de la scene en cours et fais une transition
	 * FIX ME // ONLY WORKING WITH PANZOOM ZOOM AT 1
	 * @param {*} panzoom
	 * @param {*} swiper
	 */
	updateScene: (panzoom, swiper) => {
		let targetPos = Quizz.getCurrentSceneAttr(swiper)

		var positions = Quizz.calcul_positions(targetPos)

		panzoom2.pan(
			positions.x, 
			positions.y, 
			{ 
				relative: false 
			}
		)

	},

	/**
	 * Get Panzoom current scene attributes on current slide (data-scene-x && data-scene-y)
	 * @param {Object} swiper
	 * @returns
	 */
	getCurrentSceneAttr: (swiper) => {
		let slide = Slider.getCurrentSlide(swiper)
		if (!slide) return
		let posX = slide.dataset.sceneX || 0
		let posY = slide.dataset.sceneY || 0
		let deltaXMobile = slide.dataset.delta_x_mobile || 0
		let deltaYMobile = slide.dataset.delta_y_mobile || 0
		return { x: posX, y: posY, deltaXMobile: deltaXMobile, deltaYMobile:deltaYMobile }
	},

	/**
	 * Gère la logique selon réponse choisie
	 * @param {HTMLELement} answer clicked button with data-answer
	 * @param {Object} swiper intance de swiper
	 */
	handleAnswer: (answer, swiper) => {
		let isCorrect = answer.dataset.correctAnswer
		let currentSlide = Slider.getCurrentSlide(swiper)
		Quizz.disableCurrentAnswers(currentSlide)
		currentSlide.classList.add("js-answered")


		// console.log(swiper.wrapperEl.id)


		if (isCorrect) {
			currentSlide.classList.add("js-answered--success")
			score+=1;

		} else {
			currentSlide.classList.add("js-answered--fail")
		}

		scores[swiper.wrapperEl.id] = score;
		document.querySelector(".results__score").innerHTML = score + "/10"

		Quizz.showButtonNext()
	},

	/**
	 * Désactive les boutons "réponse" de la question en cours
	 * @param {HTMLElement} currentSlide
	 */
	disableCurrentAnswers: (currentSlide) => {
		let answers = currentSlide.querySelectorAll("[data-answer]")
		answers.forEach((button) => {
			button.disabled = true
		})
	},

	showButtonNext: () => {
		if (!buttonNext) return
		buttonNext.style.display = "block"
	},

	hideButtonNext: () => {
		if (!buttonNext) return
		buttonNext.style.display = "none"
	},

	/**
	 * Transforme le bouton "next" du slider pour qu'il ouvre la modal de fin
	 * @param {String} text
	 * @param {String} modalSelector L'id de la modal à ouvrir (dataset.openModal)
	 * @returns
	 */
	alterButtonNext: (text, modalSelector) => {
		if (!buttonNext) return
		buttonNext.innerHTML = text
		buttonNext.dataset.openModal = modalSelector
		// workaround swiper
		buttonNext.disabled = false
	},
}

export default Quizz
